import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import './FocusDetailPage.css';

const FocusDetailPage = () => {
  const { focusId } = useParams();
  const navigate = useNavigate();

  // Focus area data
  const focusData = {
    'tests': {
      title: 'Sports Phychologist',
      image: 'https://img.freepik.com/free-photo/group-people-working-out-together-outdoors_23-2149891467.jpg?semt=ais_hybrid&w=740&q=80',
      description: 'Focused mental training and performance strategies that help athletes build confidence, reduce stress, and stay mentally sharp during competition.',
      fullDescription: 'Our sports psychology program focuses on enhancing athletes mental strength, confidence, and focus through scientific techniques and personalized strategies. We help athletes manage pressure, improve concentration, build resilience, and achieve peak performance consistently.',
      features: [
        'Mental strength assessment',
        'Focus and concentration training',
        'Stress and pressure management sessions',
        'Confidence-building exercises',
        'Motivation and goal-setting support',
        'Performance anxiety reduction techniques',
        'Mindfulness and relaxation practices',
        'Pre-game mental preparation strategies',
        'Post-performance psychological evaluation',
        'Personalized mental conditioning programs'
      ],
      benefits: [
        'Improve mental clarity and focus',
        'Boost confidence and self-belief',
        'Reduce performance anxiety',
        'Develop strong coping strategies',
        'Enhance motivation and consistency',
        'Strengthen emotional resilience',
        'Maintain a positive competitive mindset',
        'Handle pressure more effectively',
        'Achieve peak performance regularly',
        'Support overall psychological well-being'
      ],
      process: [
        'Initial consultation to understand challenges and goals',
        'Detailed mental performance assessment',
        'Analysis of focus, confidence, and stress factors',
        'Identification of performance barriers and patterns',
        'Development of a personalized mental training plan',
        'Regular sessions for mindset improvement and skill building',
        'Progress tracking and strategy adjustments',
        'Final evaluation and long-term performance guidance'
      ]
      ,
      duration: '2–3 hours per session',
      frequency: 'Weekly or based on athlete’s needs'

    },
    'lead-skill': {
      title: 'Sports Meditaion',
      image: 'https://askmesportsalliance.com/static/media/meditationImage.261162b4a51e790c9a70.jpeg',
      description: 'Guided meditation sessions designed to improve focus, calmness, and mental balance for athletes',
      fullDescription: 'Our sports meditation program helps athletes build stronger mental control, deeper focus, and emotional stability. Through guided breathing, mindfulness techniques, and relaxation practices, athletes learn to reduce stress, overcome performance pressure, and stay mentally balanced during training and competition.',
      features: [
        'Guided breathing and relaxation exercises',
        'Mindfulness techniques for better focus',
        'Stress and anxiety reduction practices',
        'Visualization methods for performance enhancement',
        'Mental clarity and concentration training',
        'Emotional balance and calmness development',
        'Pre-competition grounding routines',
        'Post-training mental recovery practices'
      ]
      ,
      benefits: [
        'Improved focus and mental clarity',
        'Reduced stress and performance anxiety',
        'Enhanced emotional control and stability',
        'Better concentration during training and competitions',
        'Increased mindfulness and self-awareness',
        'Faster mental recovery after intense sessions',
        'Stronger confidence and inner calm',
        'Improved overall mental well-being'
      ]
      ,
      process: [
        'Initial mindfulness and focus assessment',
        'Personalized meditation plan creation',
        'Guided one-on-one meditation sessions',
        'Group-based breathing and relaxation practices',
        'Visualization and mental conditioning exercises',
        'Progress review and technique refinement'
      ],
      duration: '6–12 months program',
      frequency: 'Weekly sessions'

    },
    'sports-nutrition': {
      title: 'Sports Nutrition',
      image: 'https://static.owayo-cdn.com/newhp/img/magazin/sportnutrition/sport-nutrition-is-perfect-before-during-and-after-exercise_670px.jpg',
      description: 'Pay-per-class online training sessions with expert coaches and instructors.',
      fullDescription: 'Our online training platform brings professional coaching directly to your home. With flexible scheduling and expert instructors, you can access high-quality training from anywhere in the world. Our pay-per-class model ensures you only pay for what you use.',
      features: [
        'Live interactive sessions',
        'Recorded session playback',
        'Personalized feedback and coaching',
        'Flexible scheduling options',
        'Multiple sports and disciplines',
        'Progress tracking and analytics'
      ],
      benefits: [
        'Convenience and flexibility',
        'Access to expert coaches worldwide',
        'Cost-effective training options',
        'No travel time or expenses',
        'Recorded sessions for review',
        'Personalized attention and feedback'
      ],
      process: [
        'Browse available classes and coaches',
        'Book your preferred time slot',
        'Join live interactive session',
        'Receive personalized feedback',
        'Access recorded session for review',
        'Track your progress over time'
      ],
      duration: '45-60 minutes per class',
      frequency: 'As per your schedule'
    },
    'online-classes': {
      title: 'Physical Fitness',
      image: 'https://images.unsplash.com/photo-1603455778956-d71832eafa4e?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGh5c2ljYWwlMjBmaXRuZXNzfGVufDB8fDB8fHww&fm=jpg&q=60&w=3000',
      description: 'Structured physical fitness programs designed to improve strength, endurance, flexibility, and overall athletic performance through expert-led training sessions and scientifically backed exercises.',
      fullDescription: 'Our physical fitness program is designed to build overall strength, endurance, and athletic capability through structured, science-based training. Guided by certified coaches, athletes engage in targeted workouts, functional movements, and performance-focused routines that promote better mobility, improved stamina, and long-term physical wellness. Whether for general fitness or competitive sports, this program helps individuals achieve their peak physical potential.'
      , features: [
        'Structured strength, endurance, and mobility workouts',
        'Expert-led training with certified fitness coaches',
        'Personalized exercise plans tailored to athlete goals',
        'Functional and sports-specific training modules',
        'Performance tracking and regular progress evaluations',
        'Guided warm-up, cooldown, and injury-prevention routines',
        'Adaptable difficulty levels for all fitness stages',
        'Consistent coaching support and technique correction'
      ]
      ,
      benefits: [
        'Improved overall strength, stamina, and mobility',
        'Enhanced athletic performance across all sports',
        'Better posture, balance, and body control',
        'Reduced risk of injuries through guided techniques',
        'Increased energy levels and daily physical efficiency',
        'Faster recovery with structured training routines',
        'Boosted confidence and physical well-being'
      ]
      ,
      process: [
        'Initial fitness assessment and goal discussion',
        'Customized workout plan designed by expert coaches',
        'Guided training sessions focusing on strength and endurance',
        'Real-time technique correction and performance feedback',
        'Review of progress with updated training adjustments',
        'Continuous monitoring to ensure steady improvement'
      ]
      ,
      duration: '45-60 minutes per class',
      frequency: 'As per your schedule'
    }
  };

  const focus = focusData[focusId];

  if (!focus) {
    return (
      <div className="focus-detail-page">
        <div className="container">
          <div className="error-message">
            <h1>Focus Area Not Found</h1>
            <p>The requested focus area could not be found.</p>
            <button onClick={() => navigate('/')} className="back-btn">
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="focus-detail-page">
      <div className="container">
        <button onClick={() => navigate('/')} className="back-btn">
          ← Back to Home
        </button>

        <div className="focus-detail-content">
          <div className="focus-image-section">
            <img src={focus.image} alt={focus.title} className="focus-detail-image" />
          </div>

          <div className="focus-info-section">
            <h1 className="focus-detail-title">{focus.title}</h1>
            <p className="focus-detail-description">{focus.fullDescription}</p>

            <div className="focus-features">
              <h3>What We Offer:</h3>
              <ul>
                {focus.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>

            <div className="focus-benefits">
              <h3>Benefits:</h3>
              <ul>
                {focus.benefits.map((benefit, index) => (
                  <li key={index}>{benefit}</li>
                ))}
              </ul>
            </div>

            <div className="focus-process">
              <h3>Our Process:</h3>
              <ol>
                {focus.process.map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ol>
            </div>

            <div className="focus-details-grid">
              <div className="detail-item">
                <h4>Duration</h4>
                <p>{focus.duration}</p>
              </div>
              <div className="detail-item">
                <h4>Frequency</h4>
                <p>{focus.frequency}</p>
              </div>
            </div>

            <div className="action-buttons">
              <Link to="/contact" className="enroll-btn">Enroll Now</Link>
              <Link to="/contact" className="contact-btn">Contact Us</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FocusDetailPage;
